import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { saveState, loadState } from "../browser-storage/browser-storage";

const type = "menuOrder";

export interface MenuOrderState {
  sideFeatureOrder: string[];
}

const initialState: MenuOrderState = {
  sideFeatureOrder: loadState(type)?.sideFeatureOrder || [],
};

export const menuOrderSlice = createSlice({
  name: type,
  initialState,
  reducers: {
    setSideFeatureOrder: (state, action: PayloadAction<string[]>) => {
      state.sideFeatureOrder = action.payload;
      saveState(type, state);
    },
    updateSideFeatureOrder: (state, action: PayloadAction<{ fromIndex: number; toIndex: number }>) => {
      const { fromIndex, toIndex } = action.payload;
      const [removed] = state.sideFeatureOrder.splice(fromIndex, 1);
      state.sideFeatureOrder.splice(toIndex, 0, removed);
      saveState(type, state);
    },
  },
});

export const { setSideFeatureOrder, updateSideFeatureOrder } = menuOrderSlice.actions;
export default menuOrderSlice.reducer;